import Player from "./components/Player";
import FieldSet from "flarum/common/components/FieldSet";
import Select from "flarum/common/components/Select";
import { extend } from "flarum/common/extend";
import ForumApplication from "flarum/forum/ForumApplication";
import app from "flarum/forum/app";
import SettingsPage from "flarum/forum/components/SettingsPage";
import RadioPlayer from './components/RadioPlayer';

app.initializers.add("nearata-listen-moe", () => {
    extend(ForumApplication.prototype, "mount", function () {
        const element = document.createElement("div");

        document.body.append(element);

        m.mount(element, RadioPlayer);
    });
});
